(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-v2"]) return;
  try {
    
  class RRGStickyHeader extends HTMLElement {
    connectedCallback() {
      this.sectionEl = this.closest('.shopify-section-header') || document.querySelector('.shopify-section-header');
      this.threshold = 20;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      window.requestAnimationFrame(() => {
        const shouldStick = window.scrollY > this.threshold;

        if (this.sectionEl) {
          this.sectionEl.classList.toggle('rrg-is-sticky', shouldStick);
        }

        this.ticking = false;
      });
    }
  }

  customElements.define('rrg-sticky-header', RRGStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = this.closest('.shopify-section-header') || document.querySelector('.shopify-section-header');
      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }
  }

  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() { super(); }

    connectedCallback() {
      super.connectedCallback();

      this.header = this.closest('.shopify-section-header') || document.querySelector('.shopify-section-header');

      this.enterAt = 20;
      this.exitAt  = 5;

      this.isStickyVisible = false;

      this.onlyOnScrollUp = this.hasAttribute('data-scroll-up');

      this.lastScrollY = window.scrollY || 0;
      this.ticking = false;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.updateStickyState();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      requestAnimationFrame(() => {
        this.updateStickyState();
        this.ticking = false;
      });
    }

    updateStickyState() {
      const y = window.scrollY || 0;
      const goingUp = y < this.lastScrollY;
      this.lastScrollY = y;

      if (y <= this.exitAt) {
        if (this.isStickyVisible) this.reset();
        this.isStickyVisible = false;
        return;
      }

      if (this.onlyOnScrollUp) {
        if (!this.isStickyVisible && y >= this.enterAt && goingUp) {
          this.reveal();
          this.isStickyVisible = true;
        } else if (this.isStickyVisible && !goingUp) {
          this.hide();
          this.isStickyVisible = false;
        }
        return;
      }

      if (!this.isStickyVisible && y >= this.enterAt) {
        this.reveal();
        this.isStickyVisible = true;
      }
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('rrg-is-sticky');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    hide() {
      this.header.classList.remove('shopify-section-header-sticky');
      this.header.classList.add('shopify-section-header-hidden');
      this.header.classList.remove('rrg-is-sticky');
      document.body.classList.remove('shopify-body-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.header.classList.remove('rrg-is-sticky');
      document.body.classList.remove('shopify-body-section-header-sticky', 'shopify-body-section-header-hidden');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
